import * as Yup from 'yup';

import i18n from '@/i18n';

export const createEditTextOverlayValidation = () => {
  return Yup.object().shape({
    value: Yup.string().required(i18n.t('valueRequired', { ns: 'common' })),
    fontFamily: Yup.string().required('fontFamilyRequired'),
    fontSize: Yup.number().required('fontSizeRequired').moreThan(0, 'fontSizeMustGreatherThanZero'),
    alignment: Yup.mixed().required('alignmentRequired'),
    startTime: Yup.number().required('timeRequired').typeError('timeRequired'),
    endTime: Yup.number().required('timeRequired').typeError('timeRequired'),
    transitionTime: Yup.number().required('timeRequired').typeError('timeRequired')
  });
};
